// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3VScQ","title":"ClientReferral_title__2JJQb","itemText":"ClientReferral_itemText__raXLl"};